<app-select-one-sla
        *ngIf="initialized && subscription"
        [slaProducts]="slaProducts"
        [subscription]="subscription"
        (selected)="onProductSelected($event)"
        (backEmitter)="onBack()">
</app-select-one-sla>